import React, { useState, useContext } from 'react'
import { compose } from 'recompose'
import { useDispatch, useSelector } from 'react-redux'
import ModalComponent from 'Components/Modal/Modal.component'
import { Grid, Button, FormControl, withStyles, Typography, FormHelperText, withWidth } from '@material-ui/core'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import plusLoadModalStyle from './PlusLoadModal.style'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { UI_PLUS_LOAD_TOO_LATE_DIALOG_CLOSE, UI_PLUS_LOAD_TOO_LATE_DIALOG_CALL_BORAL_LINK, UI_SECOND_PLUS_LOAD_MODAL_CLOSE, UI_SECOND_PLUS_LOAD_CALL_BORAL } from 'State/Store/UI/UI.types'
import { Order } from 'types/Order'
import { callBoralTel } from 'utils/call-boral-tel'
import { openSnackbar, SNACKBAR_GENERAL_ERROR_MESSAGE } from 'State/Store/Snackbar/SnackbarActionCreators'
import ServicesContext from 'Contexts/Services/Services.context'
import selectPlusLoadExceptionModalStore from 'State/Store/PlusLoadExceptionModal/PlusLoadExceptionModal.selector'
import cn from 'classnames'
import { PlusLoadExceptionModalAction, PlusLoadExceptionModalStatus } from 'State/Store/PlusLoadExceptionModal/PlusLoadExceptionModal.reducer';
import { WithWidth, isWidthDown } from '@material-ui/core/withWidth'
import { getCallBoralText } from 'ui-format-utils.ts/get-call-boral-text'

interface Props {
  order: Order,
}

interface InjectedProps {
  classes: any,
}
type FProps = Props & InjectedProps & WithWidth

const PlusLoadExceptionModalComp = (props: FProps) => {
  const {
    order,
    width,
    classes = {},
  } = props
  const dispatch = useDispatch()
  const services = useContext(ServicesContext)
  const { open, status } = useSelector(selectPlusLoadExceptionModalStore)
  const isSmallScreen = isWidthDown(`sm`, width)

  const { boralTel } = order.details
  const handleClose = () => {
    if (status === PlusLoadExceptionModalStatus.TOO_LATE) {
      dispatch(hitGTM(UI_PLUS_LOAD_TOO_LATE_DIALOG_CLOSE))
    } else if (status === PlusLoadExceptionModalStatus.SUBMITTED_OR_APPLIED) {
      dispatch(hitGTM(UI_SECOND_PLUS_LOAD_MODAL_CLOSE))
    }
    dispatch(PlusLoadExceptionModalAction.close())
  }
  const handleCallBoral = () => {
    if (status === PlusLoadExceptionModalStatus.TOO_LATE) {
      dispatch(hitGTM(UI_PLUS_LOAD_TOO_LATE_DIALOG_CALL_BORAL_LINK))
    } else if (status === PlusLoadExceptionModalStatus.SUBMITTED_OR_APPLIED) {
      dispatch(hitGTM(UI_SECOND_PLUS_LOAD_CALL_BORAL))
    }
    callBoralTel(boralTel)
  }
  const getContent = () => {
    if (status === PlusLoadExceptionModalStatus.TOO_LATE) {
      return (
        <React.Fragment>
          <Typography variant='body1' className={cn(classes.displayInline)} component='span'>
            { `Please ` }
          </Typography>
          <Typography variant='body1' className={cn(classes.displayInline, classes.fontWeight500)} component='span'>
            <a
              className={cn(classes.textDecorationUnderline, classes.cursorPointer, classes.hyperlink, classes.callBoral)}
              onClick={handleCallBoral}
            >
              { getCallBoralText({ boralTel, isSmallScreen }) }
            </a>
          </Typography>
          <Typography variant='body1' className={cn(classes.displayInline)} component='span'>
            { ` to get a plus load for this order after 4pm.` }
          </Typography>
        </React.Fragment>
      )
    } else if (status === PlusLoadExceptionModalStatus.SUBMITTED_OR_APPLIED) {
      return (
        <React.Fragment>
          <Typography variant='body1' className={cn(classes.marginBottom1unit)}>
              { `This order already has a plus load.` }
            </Typography>
          <div>
            <Typography variant='body1' className={cn(classes.displayInline)} component='span'>
              { `Please ` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.fontWeight500)} component='span'>
              <a
                className={cn(classes.textDecorationUnderline, classes.cursorPointer, classes.hyperlink, classes.callBoral)}
                onClick={handleCallBoral}
              >
                { getCallBoralText({ boralTel, isSmallScreen }) }
              </a>
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline)} component='span'>
              { ` to get additional plus loads for this order.` }
            </Typography>
          </div>
        </React.Fragment>
      )
    }
  }
  const content = getContent()
  const footer = (
    <Grid className={classes.textAlignRight} container justify='flex-end' spacing={2}>
      <Grid className={classes.flexGrow1} item>
        <Button
          className={classes.button}
          onClick={handleCallBoral}
          variant='contained'
        >
          { getCallBoralText({ boralTel, isSmallScreen }) }
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.button}
          color='primary'
          onClick={handleClose}
          variant='contained'
        >
          { `Cancel` }
        </Button>
      </Grid>
    </Grid>
  )
  return (
    <ModalComponent
      maxWidth='sm'
      fullWidth
      open={open}
      onClose={handleClose}
      rightHeading={null}
      title={'Get a Plus Load'}
      icon={null}
      content={content}
      footer={footer}
    />
  )
}


const PlusLoadExceptionModal = compose<FProps, Props>(
  withWidth(),
  withStyles(themeCreateInjectableStyles(plusLoadModalStyle) as any, { withTheme: true }),
)(PlusLoadExceptionModalComp)

export default PlusLoadExceptionModal
